import { useState } from "react";
import { createPortal } from "react-dom";
import { Save } from "lucide-react";
import { toast } from "sonner";
import api, { errText } from "@/lib/api";

export const AttendeeNote = ({ eventId, attendee, onClose, onSaved }) => {
  const [note, setNote] = useState(attendee.note || "");
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post(
        `/events/${eventId}/registrations/${attendee.registration_id}/note`,
        { note }
      );
      toast.success(data.note ? "Note saved" : "Note cleared");
      onSaved(data.note);
      onClose();
    } catch (err) {
      toast.error(errText(err));
    } finally {
      setBusy(false);
    }
  };

  return createPortal(
    <div className="fixed inset-0 z-[100] bg-black/80 overflow-y-auto p-4" onClick={onClose}>
      <form
        onSubmit={save}
        onClick={(e) => e.stopPropagation()}
        className="card p-7 max-w-lg w-full mx-auto my-16"
        data-testid="attendee-note-modal"
      >
        <h3 className="font-display text-lg font-black">Note on {attendee.first_name} {attendee.last_name}</h3>
        <p className="text-xs text-slate-400 mt-2" data-testid="attendee-note-details">
          {attendee.email} · ref{" "}
          <span className="font-mono2 text-slate-200">{attendee.registration_code}</span>
        </p>
        <textarea
          className="input mt-5 h-28 resize-none"
          maxLength={300}
          autoFocus
          placeholder="e.g. replied yes by phone on 3 Jul"
          data-testid="attendee-note-input"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
        <p className="text-[11px] text-slate-500 mt-1.5">
          {note.length}/300 · organiser only — never shown to the guest, never emailed.
        </p>
        <div className="flex flex-wrap gap-3 mt-6">
          <button className="btn-primary" disabled={busy} data-testid="attendee-note-save-btn">
            <Save size={15} /> {busy ? "Saving…" : "Save note"}
          </button>
          <button type="button" onClick={onClose} className="btn-secondary"
            data-testid="attendee-note-cancel-btn">
            Cancel
          </button>
        </div>
      </form>
    </div>,
    document.body
  );
};
